var render, staticRenderFns
import script from "./CustomTab.vue?vue&type=script&lang=ts&"
export * from "./CustomTab.vue?vue&type=script&lang=ts&"
import style0 from "./CustomTab.vue?vue&type=style&index=0&id=f955e6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f955e6fc",
  null
  
)

export default component.exports